import React, {useRef} from 'react'
import Hero from '../component/LandingPageComponents/Hero/Hero'
import NewApproach from '../component/LandingPageComponents/NewApproach/NewApproach'
import CareDelivery from '../component/LandingPageComponents/CareDelivery/CareDelivery'
import OptimalHealthPath from '../component/LandingPageComponents/OptimalHealthPath/OptimalHealthPath';
import EmpowerBanner from '../component/LandingPageComponents/EmpowerBanner/EmpowerBanner';
import ProgramGrid from '../component/LandingPageComponents/ProgramGrid/ProgramGrid';
import FaqSection from '../component/LandingPageComponents/FaqSection/FaqSection';
import TeamCare from '../component/LandingPageComponents/TeamCare/TeamCare';
import TestimonialsNew from '../component/InstaImageGallery/InstaImageGallery';
import FooterBanner from '../component/LandingPageComponents/Hero/FooterBanner/FooterBanner';

function LandingPage() {

  const calendlyFormRef = useRef(null);

  const scrollToFormAndHighlight = (e) => {
    if (e) e.preventDefault();
    if (calendlyFormRef.current) {
      calendlyFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });

      calendlyFormRef.current.classList.remove('ttc-hero-form-glow');
      void calendlyFormRef.current.offsetWidth;
      calendlyFormRef.current.classList.add('ttc-hero-form-glow');

      setTimeout(() => {
        if (calendlyFormRef.current) {
          calendlyFormRef.current.classList.remove('ttc-hero-form-glow');
        }
      }, 2500);
    }
  };

  return (
    <div>
        <Hero
        calendlyFormRef={calendlyFormRef} 
        onCtaClick={scrollToFormAndHighlight}
        />
        <NewApproach/>
        <CareDelivery 
        onCardClick={scrollToFormAndHighlight} 
        />
        <OptimalHealthPath 
         onCtaClick={scrollToFormAndHighlight}
         />

         <EmpowerBanner 
          onCtaClick={scrollToFormAndHighlight}
         />

         <ProgramGrid
          onCtaClick={scrollToFormAndHighlight}
         />

         <FaqSection/>

         <TeamCare
          onConsultationClick={scrollToFormAndHighlight}
         />

         <TestimonialsNew/>

          <EmpowerBanner 
          onCtaClick={scrollToFormAndHighlight}
           backgroundImage = '/images/creatives/landing-banner-2-bg.jpg'
  headingLine1 = 'The path to health'
  headingLine2 = 'begins here, take'
  headingItalic = 'the first step'
  description = 'At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control.'
  btnText = 'Book A Consultation'
         />

         <FooterBanner/>
    </div>
  )
}

export default LandingPage